import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from '@eti/providers';
import { BoundNew } from '@eti/types';
import { routes } from '../../../../constants/routesAndApisConstants';
import { addLegendNumberToSegmentEvents } from '../../utils/formatUtils';
import ReviewTripDetailsBound from './ReviewTripDetailsBound';
import ReviewModalSection from './ReviewModalSection';

const ReviewFlightDetails = ({ bounds, isMultiStop }) => {
  const history = useHistory();
  const { t } = useTranslation();

  const searchVariables = history?.location?.state?.searchVariables ?? {};
  const flightInformationButton = {
    onClick: () => {
      history.push(routes.RESULT, { searchVariables });
    },
    text: t('TravelerDetails.Review.Modal.Flight.Edit.Label'),
    testId: 'travelerDetails-reviewModal-flightInformation',
  };

  return (
    <ReviewModalSection
      button={flightInformationButton}
      title={t('TravelerDetails.Review.Modal.Flight.Label')}
    >
      {addLegendNumberToSegmentEvents(bounds).map((bound, index) => (
        <ReviewTripDetailsBound
          bound={bound}
          boundNumber={index + 1}
          isMultiStop={isMultiStop}
          key={`bound-${bound.boundId}-${index + 1}`}
        />
      ))}
    </ReviewModalSection>
  );
};

ReviewFlightDetails.propTypes = {
  bounds: PropTypes.arrayOf(BoundNew),
  isMultiStop: PropTypes.bool,
};

export default ReviewFlightDetails;
